// extracted by mini-css-extract-plugin
export var logo = "product-header-module--logo--96546";
export var productHeader = "product-header-module--productHeader--2246d";
export var title = "product-header-module--title--c8dfd";
export var tm = "product-header-module--tm--81544";